import SimpleInfoModal from "./SimpleInfoModal";
import React from "react";
import CongratsIcon from "./CongratsIcon";

export const ConfModal = {
  TermLifeSpecialOffer: {
    GI: ({show, onHide}: {show: boolean, onHide: () => void}) => (
      <SimpleInfoModal
        show={show}
        onHide={onHide}
        title="Congratulations on selecting this special insurance offer!"
        body={<div><p>Your application is processing, and your certificate will be delivered to your email or via the mail, whichever you selected.</p><p> Please call us at <a href="tel:888-423-8700">888-423-8700</a>, M-F 8 am – 8 pm est with any questions you may have.</p></div>}        
      />
    ),
    SI: ({show, onHide}: {show: boolean, onHide: () => void}) => (
      <SimpleInfoModal
        show={show}
        onHide={onHide}
        title="Congratulations on selecting additional insurance!"
        body={<div><p>Since you also selected coverage that requires medical information, your application has been sent for underwriting for approval. Please allow 3-5 business days for its initial review. If not approved, the guaranteed amount of $50,000 will still be issued. After your application processes your certificate will be delivered to your email or via the mail, whichever you selected.</p><p>Please call us at <a href="tel:888-423-8700">888-423-8700</a>, M-F 8 am – 8 pm est with any questions you may have.</p></div>}        
      />
    )
  }
};

export default ConfModal;
